
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timesheet",
      function () {
        return require("private-next-pages/timesheet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timesheet"])
      });
    }
  